import React, { ReactNode } from 'react';
import { SvgIconProps } from 'ui/icons/SvgIcon';

export enum RADIO_LIST_VARIANTS {
  BORDERED = 'bordered',
  DEFAULT = 'default',
}

export type Option = {
  /* Descriptive text to display below the label */
  description?: string | ReactNode;
  /* Helper icon svg icon props */
  helperIconProps?: SvgIconProps;
  /* Optional icon in top right corner */
  Icon?: React.FC<React.PropsWithChildren<{ color: string }>>;
  /* Unique identifier for the option */
  id: string;
  /* Whether the option is disabled */
  isDisabled?: boolean;
  /* Whether tooltip is enabled */
  isTooltipEnabled?: boolean;
  /* Whether a clickable helper icon is enabled */
  isHelperIconEnabled?: boolean;
  /* Human-readable label displayed beside the name */
  label?: string;
  /* Human-readable name of option. Can be function component. */
  name: string | React.FC<React.PropsWithChildren<unknown>>;
  /* Tooltip to display for list option */
  tooltipContent?: string | ReactNode;
  /* Helper icon content to display for list option */
  helperIconContent?: string | ReactNode;
  /* Value of the option; must be unique */
  value: any;
};

export type Props = {
  /* Label for the radio group */
  label?: string;
  /* Unique identifier for form field, passed down to all options */
  name: string;
  /* Callback to trigger on selection of an option. Receives the selected option's value */
  onSelect?: (value: any) => void;
  /* Available options */
  options: Option[];
  /* Currently selected value, to be passed by controlling parent */
  value?: string | number;
  /* Variant, bordered or default */
  variant: RADIO_LIST_VARIANTS;
  /* Whether the radio group is disabled entirely */
  isReadOnly?: boolean;
  /** Whether label is regular or bold */
  isRegularWeight?: boolean;
};
